
import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';


export default function BlogRequestBasicInfoComponent({ influencer, handleBlogPost, taskStatus, handleInnerFormChange, selectedBlog }: any) {
  return (
    <>
      <div className='flex w-full justify-end items-end'>
        <button
          onClick={handleBlogPost}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Create Blog Post
        </button>
      </div>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Subject"
              labelField="Subject"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Subject'
                );
              }}
              type="text"
              value={selectedBlog?.Subject}
            />
            <InputContainer
              label="Status"
              labelField="Text"
              list={taskStatus}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Status'
                );
              }}
              optionName='Choose Status'
              type="select"
              value={selectedBlog?.Status}
              valueField="Value"
            />
            <InputContainer
              label="Start Date"
              name="StartDate"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'StartDate'
                )
              }}
              type="date"
              value={selectedBlog?.StartDate}
            />
            <InputContainer
              label="End Date"
              name="EndDate"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'EndDate'
                )
              }}
              type="date"
              value={selectedBlog?.EndDate}
            />
            <InputContainer
              label="Source"
              labelField="InfluencerName"
              list={influencer}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'SourceId'
                );
              }}
              optionName='Choose Source'
              type="select"
              value={selectedBlog?.SourceId}
              valueField="Id"
            />
            <div className='col-span-full'>
              <InputContainer
                label="Body"
                name="Body"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Body'
                  )
                }}
                type="text"
                value={selectedBlog?.Body}
              /></div>
          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Info"
      />
    </>
  )
}